export default __webpack_public_path__ + "static/media/wbtc.7575c805.svg";